import {
  CourseCard,
  CourseCardPlaceholder,
  NoData,
  Paginator,
} from "@components";
import { DEFAULT_PAGE_SIZE } from "@constants";
import { searchParamsToObject } from "@helpers";
import { exploreCourseAction } from "@redux/actions";
import { bool, object, string } from "prop-types";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { defaultFilters, sortOptions } from "../Data";

const SearchResult = ({ filterUIVisible, extraSearchParams, courseType }) => {
  // state

  // variables
  let pagination = null;

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { exploreCourse } = useSelector((state) => state.course);

  // logics
  const coursePlaceholderData = Array.from(
    Array(Number(searchParams.get("PageSize")) || DEFAULT_PAGE_SIZE).keys()
  );
  const coursesData = exploreCourse.data ?? [];
  const isResultEmpty = !coursesData.length;

  // UI partials
  if (exploreCourse.pagination) {
    pagination = <Paginator data={{ ...exploreCourse.pagination }} />;
  }

  const coursesPlaceholder = coursePlaceholderData.map((key) => (
    <Col
      key={key}
      xs={12}
      sm={6}
      lg={filterUIVisible ? 6 : 4}
      xl={filterUIVisible ? 4 : 3}
    >
      <CourseCardPlaceholder />
    </Col>
  ));
  const emptyResult = (
    <Col xs={12}>
      <NoData title="No Course Found!" message="Try something else" />
    </Col>
  );

  const courses = coursesData.map((item, index) => (
    <Col
      key={item.id || index}
      xs={12}
      sm={6}
      lg={filterUIVisible ? 6 : 4}
      xl={filterUIVisible ? 4 : 3}
    >
      <CourseCard data={item} type={courseType} />
    </Col>
  ));

  // effects
  useEffect(() => {
    const Keyword = (searchParams.get("Keyword") || "")
      .replace(/\s+/g, " ")
      .trim();
    const Orderby = searchParams.get("Orderby") || sortOptions[0].value;
    const PageSize = Number(searchParams.get("PageSize")) || DEFAULT_PAGE_SIZE;
    const PageNumber = Number(searchParams.get("PageNumber")) || 1;
    const [currentFilters] = searchParamsToObject(searchParams, defaultFilters);

    dispatch(
      exploreCourseAction({
        ...currentFilters,
        Keyword,
        Orderby,
        PageSize,
        PageNumber,
        status: 1,
        IsActive: true,
        ...extraSearchParams,
      })
    );
  }, [dispatch, searchParams]);

  // render
  return (
    <Row style={{ rowGap: "1.5rem" }}>
      {exploreCourse.processing
        ? coursesPlaceholder
        : isResultEmpty
        ? emptyResult
        : courses}
      <div className="d-flex justify-content-center">{pagination}</div>
    </Row>
  );
};

/* required: display name */
SearchResult.displayName = "SearchResult";

/* required: props types */
SearchResult.propTypes = {
  filterUIVisible: bool,
  extraSearchParams: object,
  courseType: string,
};

/* required: default props */
SearchResult.defaultProps = {
  filterUIVisible: false,
  extraSearchParams: {},
  courseType: "",
};

export { SearchResult };
